export const language: any = {
  selected_ingredients: "Ingrédients sélectionnés",
  recommend: "Plats recommandés",
  title_detail: "Recettes recommandées",
  share: "Partager",
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">Ingrédients</span> <span class="tracking-tighter whitespace-nowrap">(1 portion)</span>`,
    add_all: "Ajouter tous les ingrédients",
    view_more: "{number} ingrédients supplémentaires",
    view_less: "Réduire",
    delete_all: "Supprimer tous les ingrédients"
  },
  how_to_cook: "Méthode de cuisson",
  video: {
    title: "Recette en vidéo"
  },
  msg: {
    msg_1: "Êtes-vous sûr de vouloir supprimer cet ingrédient ?",
    msg_2: "Êtes-vous sûr de vouloir supprimer tous les ingrédients ?",
    msg_3: "Souhaitez-vous ajouter les ingrédients ?",
    msg_4: "Souhaitez-vous ajouter tous les ingrédients manquants ?",
    msg_5: "Souhaitez-vous ajouter les ingrédients sélectionnés à votre panier ?",
    msg_6: "Cet ingrédient est déjà dans votre panier.",
    confirm: "Oui",
    cancel: "Non"
  },
  recipe_exist_in_cart: "Cet ingrédient est déjà dans votre panier.",
  recipe_want_add_to_cart: "Souhaitez-vous ajouter les ingrédients sélectionnés à votre panier ?",
  recipe_exist_in_cart_should_exclued: "est déjà dans le panier actuel et a donc été exclu.",
  calories_description: "Ce plat est estimé à {calories} calories selon la recette ci-dessous. Faites le bon choix pour votre santé !",
  title_share_sns: "Partager cette recette sur",
  copy: "Copier",
  recipe_add_cart_success: "Ajouté au panier. Souhaitez-vous aller à l'écran du panier ?",
  recipe_close: "Fermer",
  recipe_move: "Aller",
  recipe_add_ingredient_success: "L'ingrédient sélectionné a été ajouté. Voulez-vous passer à l'écran des ingrédients ?",
  copied: "Copié",
  text_share_sns: `{recipe_name}, que pensez-vous de cette recette ?\nDécouvrez-la sur Hey! Cooker !`,
  search: {
    title: "Rechercher des recettes",
    searching: "Hey Cooker recherche des recettes correspondant<br/> à vos mots-clés, veuillez patienter un instant !",
    not_found: "Hmm, le chef IA n'a trouvé aucun plat correspondant<br/> à vos mots-clés. Veuillez essayer avec un autre nom de recette.",
    placeholder: "Entrez le nom de la recette que vous souhaitez rechercher...",
    msg_default_recipe: "Vous n'avez encore aucune recette."
  },
  noData: "Aucun résultat trouvé",
  searching: "Recherche en cours..."
}
